var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H52C56.4183 0 60 3.58172 60 8V52C60 56.4183 56.4183 60 52 60H8C3.58172 60 0 56.4183 0 52V8Z",
    fill: "#2773FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2232_3319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 45.5C37.7843 45.5 44.5 38.7843 44.5 30.5C44.5 22.2157 37.7843 15.5 29.5 15.5C21.2157 15.5 14.5 22.2157 14.5 30.5C14.5 38.7843 21.2157 45.5 29.5 45.5Z",
    stroke: "#FBFCFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 24.5V30.0986C29.5 30.3494 29.6254 30.5836 29.8339 30.7226L34 33.5",
    stroke: "#FBFCFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2232_3319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 22C13 17.5817 16.5817 14 21 14H38C42.4183 14 46 17.5817 46 22V39C46 43.4183 42.4183 47 38 47H21C16.5817 47 13 43.4183 13 39V22Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.8accbab10fcfa5a80773e7e286327541.svg";
export { ForwardRef as ReactComponent };